// src/context/AuthContext.js
import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { toast } from "react-toastify";
import { handleError } from "../utils/helper";
import { readContracts } from "@wagmi/core";
import { config } from "../config";
import { ICO_ABI } from "../Contract/ICO_ABI";
import { ICO_CONTRACT_ADDRESS } from "../utils/constant";
import { formatUnits } from "viem";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profile, setProfile] = useState(null); // for admin profile
  const [loading, setLoading] = useState(true);
  const [icoValues, setIcoValues] = useState({
    usdtValue: "",
    soldOut: "",
  });

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const storedProfile = localStorage.getItem("profile");
    setIsAuthenticated(!!token);
    if (storedProfile) {
      setProfile(JSON.parse(storedProfile));
    }
    setLoading(false);
  }, []);

  const login = (token, profileData) => {
    console.log("token and profileData : ", token, profileData);
    sessionStorage.setItem("token", token);
    localStorage.setItem("profile", JSON.stringify(profileData));
    setIsAuthenticated(true);
    setProfile(profileData);
  };

  const logout = () => {
    sessionStorage.removeItem("token");
    localStorage.removeItem("profile");
    setIsAuthenticated(false);
    setProfile(null);
  };

  const fetchIcoValues = useCallback(async () => {
    try {
      setLoading(true);

      const results = await readContracts(config, {
        contracts: [
          {
            abi: ICO_ABI,
            address: ICO_CONTRACT_ADDRESS,
            functionName: "tokenPriceInUSD",
          },
          {
            abi: ICO_ABI,
            address: ICO_CONTRACT_ADDRESS,
            functionName: "totalSold",
          },
        ],
      });

      const eachTokenPrice = formatUnits(results[0].result, 8);
      const totalSold = formatUnits(results[1].result, 18);

      console.log("totalSold", totalSold);
      console.log("eachTokenPrice", eachTokenPrice);

      setIcoValues((prev) => ({
        ...prev,
        usdtValue: eachTokenPrice,
        soldOut: totalSold,
      }));
    } catch (error) {
      const contractError = handleError(error?.cause?.data);
      console.error("Something went wrong:", contractError);
    } finally {
      setLoading(false);
    }
  }, []); // Empty deps since it doesn't rely on external state

  useEffect(() => {
    fetchIcoValues();
  }, [fetchIcoValues]);

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        profile,
        setProfile,
        loading,
        icoValues,
        setIcoValues,
        fetchIcoValues,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
